import { X, Zap, Flame, Leaf, ClipboardCheck, MessageSquare, CreditCard } from "lucide-react";

const PACKS = [
  { type: "electrical", label: "Electrical", amount: "20 credits", price: "£5", color: "#00A3E0", bg: "#E8F7FC", Icon: Zap },
  { type: "gas", label: "Gas & Boiler", amount: "50 credits", price: "£5", color: "#EF4444", bg: "#FEECEC", Icon: Flame },
  { type: "mcs", label: "MCS / Renewables", amount: "20 credits", price: "£5", color: "#22C55E", bg: "#EAFBF0", Icon: Leaf },
  { type: "pat", label: "PAT Testing", amount: "10 credits", price: "£5", color: "#8B5CF6", bg: "#F3EFFE", Icon: ClipboardCheck },
];

export default function CreditShopModal({ open, onClose, onBuy, onBuySms }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" data-testid="credit-shop-modal">
      <div className="fixed inset-0 bg-black/40" onClick={onClose} />
      <div className="relative w-full max-w-md mx-4 rounded-t-2xl sm:rounded-2xl overflow-hidden animate-fade-in-up" style={{ backgroundColor: 'var(--bg-card)' }}>
        <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: 'var(--border-light)' }}>
          <div className="flex items-center gap-2">
            <CreditCard className="w-5 h-5 text-[#00A3E0]" />
            <h3 className="text-base font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--text-primary)' }}>Buy Credits</h3>
          </div>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100" data-testid="close-credit-shop">
            <X className="w-5 h-5" style={{ color: 'var(--text-muted)' }} />
          </button>
        </div>

        <div className="px-5 py-4 space-y-2.5 max-h-[70vh] overflow-y-auto">
          {PACKS.map((p) => (
            <button key={p.type} onClick={() => { onBuy(p.type); onClose(); }} data-testid={`shop-buy-${p.type}`}
              className="w-full flex items-center gap-3 p-3.5 rounded-xl transition-all hover:shadow-md text-left"
              style={{ backgroundColor: 'var(--row-alt)' }}>
              <div className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: p.bg }}>
                <p.Icon className="w-5 h-5" style={{ color: p.color }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--text-primary)' }}>{p.label}</p>
                <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>{p.amount}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-base font-bold" style={{ fontFamily: 'IBM Plex Mono, monospace', color: p.color }}>{p.price}</p>
              </div>
            </button>
          ))}

          {/* SMS Credits */}
          <button onClick={() => { onBuySms(); onClose(); }} data-testid="shop-buy-sms"
            className="w-full flex items-center gap-3 p-3.5 rounded-xl transition-all hover:shadow-md text-left"
            style={{ backgroundColor: 'var(--row-alt)' }}>
            <div className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FEF3C7' }}>
              <MessageSquare className="w-5 h-5 text-[#D97706]" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--text-primary)' }}>SMS Messages</p>
              <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>100 credits</p>
            </div>
            <div className="text-right flex-shrink-0">
              <p className="text-base font-bold" style={{ fontFamily: 'IBM Plex Mono, monospace', color: '#D97706' }}>£7</p>
            </div>
          </button>
        </div>

        <div className="px-5 py-3 border-t text-center" style={{ borderColor: 'var(--border-light)' }}>
          <p className="text-[10px]" style={{ color: 'var(--text-muted)' }}>Secure payment via Stripe. Credits never expire.</p>
        </div>
      </div>
    </div>
  );
}
